'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.init = undefined;

var _jquery = require('jquery');

var _jquery2 = _interopRequireDefault(_jquery);

var _dom = require('../common/dom.js');

var _dom2 = _interopRequireDefault(_dom);

var _jsCookie = require('js-cookie');

var _jsCookie2 = _interopRequireDefault(_jsCookie);

var _themeCurrency = require('@shopify/theme-currency');

var currency = _interopRequireWildcard(_themeCurrency);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var shopCurrency = (0, _jquery2.default)('body').attr('data-shop-currency');
var $product = (0, _jquery2.default)(_dom2.default.productForm);

var bindUIActions = function bindUIActions() {
  (0, _jquery2.default)(document).on('click', '.js-finish-panel-trigger', function (event) {
    if ((0, _jquery2.default)(event.target).hasClass('tooltip-link')) {
      return true;
    }
    var panelName = (0, _jquery2.default)(this).attr('data-frame-handle');
    if (panelName) {
      var $panel = (0, _jquery2.default)('.pdp__finish-panel[data-frame-handle="' + panelName + '"]');
      (0, _jquery2.default)('.pdp__finish-panel').removeClass('is-active');
      $panel.addClass('is-active');

      //Scroll to top when opening finish panel
      if (0 < (0, _jquery2.default)(window).scrollTop()) {
        (0, _jquery2.default)('html, body').animate({
          scrollTop: 0
        }, 500);
      }

      if ((0, _jquery2.default)(window).width() < 728) {
        _dom2.default.$hoverOverlay.addClass('is-active');
        _dom2.default.$html.addClass('drawer-active');
      }
    }
  });

  (0, _jquery2.default)(document).on('click', '[data-finish-select]', function (event) {
    var $finish = (0, _jquery2.default)(this);
    if ($finish.hasClass('unavailable')) {
      return false;
    }
    var finishId = $finish.attr('data-variant-id');
    var handle = $finish.attr('data-frame-handle');

    var finishTitle = $finish.attr('data-frame-title');

    if ($finish.attr('data-variant-title') != undefined && finishTitle != $finish.attr('data-variant-title')) {
      finishTitle += ', ' + $finish.attr('data-variant-title');
    }

    if ($finish.hasClass('selected')) {
      $finish.removeClass('selected');
      // for now, if they click a selected option we treat that as unselecting it
      // so switch the parent option's image back to default
      if (handle) {
        var $parentOption = (0, _jquery2.default)('.js-finish-panel-trigger[data-frame-handle="' + handle + '"]');
        var imageSrc = $parentOption.attr('data-image-src');
        $parentOption.removeClass('selected');
        $parentOption.find('img').attr('src', imageSrc);
      }
      _jsCookie2.default.remove('finish_type');
      (0, _jquery2.default)(_dom2.default.customFinish).val(null);
      (0, _jquery2.default)(_dom2.default.customFinishId).val(null);
      (0, _jquery2.default)(_dom2.default.customFinishPrice).val(null);
      // update price back to default in top and atc button
      var price = parseFloat($product.attr('data-price'));
      var final_price = currency.formatMoney(price, "${{amount}} " + shopCurrency);

      (0, _jquery2.default)('[data-product-price]').html(final_price);
      (0, _jquery2.default)('[data-add-to-cart-price]').html(final_price);

      var compare_price = parseFloat($product.attr('data-compare-price'));
      if (compare_price > 0) {
        var final_compare_price = currency.formatMoney(compare_price, "${{amount}} " + shopCurrency);

        (0, _jquery2.default)('[data-product-compare-price]').html(final_compare_price).removeClass('hide');
      }

      if ($finish.closest('[data-finish-panel]').length > 0) {
        $finish.closest('[data-finish-panel]').find(_dom2.default.finishAddon).removeClass('is-active');
      }
    } else {
      (0, _jquery2.default)('[data-finish-select]').removeClass('selected');
      $finish.addClass('selected');

      if (handle) {
        var _imageSrc = $finish.find('img').attr('src');
        (0, _jquery2.default)('.js-finish-panel-trigger').removeClass('selected');
        var _$parentOption = (0, _jquery2.default)('.js-finish-panel-trigger[data-frame-handle="' + handle + '"]');
        _$parentOption.addClass('selected');
        _$parentOption.find('img').attr('src', _imageSrc);
      }

      // update price
      var _price = parseFloat($finish.attr('data-price'));

      if (_price) {
        var product_price = parseFloat($product.attr('data-price'));
        var _compare_price = parseFloat($product.attr('data-compare-price'));
        var total_price = _price + product_price;
        var total_compare_price = _price + _compare_price;
        var _final_price = currency.formatMoney(total_price, "${{amount}} " + shopCurrency);

        // FIX: use a dom variable
        (0, _jquery2.default)('[data-product-price]').html(_final_price);
        (0, _jquery2.default)('[data-add-to-cart-price]').html(_final_price);
        if (_compare_price > 0) {
          var _final_compare_price = currency.formatMoney(total_compare_price, "${{amount}} " + shopCurrency);
          (0, _jquery2.default)('[data-product-compare-price]').html(_final_compare_price).removeClass('hide');
        } else {
          (0, _jquery2.default)('[data-product-compare-price]').addClass('hide');
        }
        _jsCookie2.default.set('finish_price', _price);
        (0, _jquery2.default)(_dom2.default.customFinishPrice).val(_final_price);
      }

      // update supplier code 
      var supplierCode = $finish.attr('data-frame-supplier-code');
      _jsCookie2.default.set('finish_code', supplierCode);

      // Check if dry mounted option is available
      var dryMounted = (0, _jquery2.default)(this).attr('data-finish-dry-mounted-activate') === '';

      if (dryMounted) {
        (0, _jquery2.default)('[data-finish-dry-mounted]').addClass('is-active');
      } else {
        (0, _jquery2.default)('[data-finish-dry-mounted]').removeClass('is-active');
      }

      // Check if addon is available
      var hasAddon = (0, _jquery2.default)(this).attr('data-finish-addon-activate') === '';

      if (hasAddon) {
        (0, _jquery2.default)('[data-finish-addon-product]').addClass('is-active');
      } else {
        (0, _jquery2.default)('[data-finish-addon-product]').removeClass('is-active');
      }

      _jsCookie2.default.set('finish_type', finishId);
      (0, _jquery2.default)(_dom2.default.customFinishId).val(finishId);
      (0, _jquery2.default)(_dom2.default.customFinish).val(finishTitle);
    }

    //Reset Plexiglass
    (0, _jquery2.default)(_dom2.default.finishAddonTrigger).removeClass('is-active');
    (0, _jquery2.default)(_dom2.default.customFinishAddon).val(null);
    (0, _jquery2.default)(_dom2.default.customFinishAddonId).val(null);

    // hide the panel
    var $panel = $finish.parents('.pdp__finish-panel');
    $panel.removeClass('is-active');
    _dom2.default.$hoverOverlay.removeClass('is-active');
    _dom2.default.$html.removeClass('drawer-active');
  });

  //Hide Finish Panel when clicking on the site content
  (0, _jquery2.default)('#siteContent').on('click', hideFinishPanel);
  (0, _jquery2.default)('#siteContent').on('click', '*', hideFinishPanel);
  (0, _jquery2.default)(document).on('keyup', function (key) {
    if (key.keyCode == 27) {
      hideFinishPanel(_dom2.default.finishPanel);
    }
  });
  function hideFinishPanel(e) {
    if (!(0, _jquery2.default)(_dom2.default.finishPanel).is(e.target) && (0, _jquery2.default)(_dom2.default.finishPanel).has(e.target).length === 0) {
      if ((0, _jquery2.default)(_dom2.default.finishPanel).hasClass('is-active')) {
        (0, _jquery2.default)(_dom2.default.finishPanel).removeClass('is-active');
      }
    }
  }

  (0, _jquery2.default)(document).on('click', '.pdp__close--finish', function (event) {
    (0, _jquery2.default)(this).parents('.pdp__finish-panel').removeClass('is-active');
    _dom2.default.$hoverOverlay.removeClass('is-active');
    _dom2.default.$html.removeClass('drawer-active');
  });

  (0, _jquery2.default)(document).on('click', _dom2.default.finishMoreOptionsTrigger, function () {
    (0, _jquery2.default)(this).remove();
    (0, _jquery2.default)(_dom2.default.finishMoreOptions).addClass('is-active');
  });

  (0, _jquery2.default)(document).on('click', '[data-finish-dry-mounted-trigger]', function () {
    if (!(0, _jquery2.default)(this).hasClass('is-active')) {
      (0, _jquery2.default)(this).addClass('is-active');
      (0, _jquery2.default)('[data-custom-finish-dry-mounted]').val('Dry Mounted');
    } else {
      (0, _jquery2.default)(this).removeClass('is-active');
      (0, _jquery2.default)('[data-custom-finish-dry-mounted]').val('Not Dry Mounted');
    }
  });

  (0, _jquery2.default)(document).on('click', _dom2.default.finishAddonTrigger, function () {
    var $addonProduct = (0, _jquery2.default)(this).closest(_dom2.default.finishAddon);

    var price = parseFloat($addonProduct.attr('data-price'));
    var finishPrice = parseFloat(_jsCookie2.default.get('finish_price'));
    var productPrice = parseFloat($product.attr('data-price'));
    var comparePrice = parseFloat($product.attr('data-compare-price'));

    if (!(0, _jquery2.default)(this).hasClass('is-active')) {
      (0, _jquery2.default)(this).addClass('is-active');

      var addonTitle = $addonProduct.attr('data-product-title');
      var addonId = $addonProduct.attr('data-variant-id');

      if (price) {
        var totalPrice = price + finishPrice + productPrice;
        var totalComparePrice = price + finishPrice + comparePrice;
        var finalPrice = currency.formatMoney(totalPrice, "${{amount}} " + shopCurrency);

        (0, _jquery2.default)('[data-product-price]').html(finalPrice);
        (0, _jquery2.default)('[data-add-to-cart-price]').html(finalPrice);

        if (comparePrice > 0) {
          var finalComparePrice = currency.formatMoney(totalComparePrice, "${{amount}} " + shopCurrency);
          (0, _jquery2.default)('[data-product-compare-price]').html(finalComparePrice).removeClass('hide');
        } else {
          (0, _jquery2.default)('[data-product-compare-price]').addClass('hide');
        }

        (0, _jquery2.default)(_dom2.default.customFinishPrice).val(finalPrice);
      }

      (0, _jquery2.default)(_dom2.default.customFinishAddon).val(addonTitle);
      (0, _jquery2.default)(_dom2.default.customFinishAddonId).val(addonId);
    } else {
      (0, _jquery2.default)(this).removeClass('is-active');
      (0, _jquery2.default)(_dom2.default.customFinishAddon).val(null);
      (0, _jquery2.default)(_dom2.default.customFinishAddonId).val(null);

      var _totalPrice = finishPrice + productPrice;
      var _totalComparePrice = finishPrice + comparePrice;
      var _finalPrice = currency.formatMoney(_totalPrice, "${{amount}} " + shopCurrency);

      (0, _jquery2.default)('[data-product-price]').html(_finalPrice);
      (0, _jquery2.default)('[data-add-to-cart-price]').html(_finalPrice);

      if (comparePrice > 0) {
        var _finalComparePrice = currency.formatMoney(_totalComparePrice, "${{amount}} " + shopCurrency);
        (0, _jquery2.default)('[data-product-compare-price]').html(_finalComparePrice).removeClass('hide');
      } else {
        (0, _jquery2.default)('[data-product-compare-price]').addClass('hide');
      }

      (0, _jquery2.default)(_dom2.default.customFinishPrice).val(_finalPrice);
    }
  });
  (0, _jquery2.default)(document).on('click', _dom2.default.finishRemove, function () {
    if ((0, _jquery2.default)(this).siblings('.pdp__finish-block').hasClass('selected')) {
      (0, _jquery2.default)('.pdp__finish-block').removeClass('selected');

      var $finish = (0, _jquery2.default)(this).siblings('.pdp__finish-block');
      if ($finish.hasClass('unavailable')) {
        return false;
      }
      var finishId = $finish.attr('data-variant-id');
      var handle = $finish.attr('data-frame-handle');

      var finishTitle = $finish.attr('data-frame-title');

      if ($finish.attr('data-variant-title') != undefined && finishTitle != $finish.attr('data-variant-title')) {
        finishTitle += ', ' + $finish.attr('data-variant-title');
      }

      if (handle) {
        var $parentOption = (0, _jquery2.default)('.js-finish-panel-trigger[data-frame-handle="' + handle + '"]');
        var imageSrc = $parentOption.attr('data-image-src');
        $parentOption.removeClass('selected');
        $parentOption.find('img').attr('src', imageSrc);
      }

      if ((0, _jquery2.default)('[data-finish-dry-mounted]').hasClass('is-active')) {
        (0, _jquery2.default)('[data-finish-dry-mounted]').removeClass('is-active');
      }
      if ((0, _jquery2.default)('[data-finish-addon-product]').hasClass('is-active')) {
        (0, _jquery2.default)('[data-finish-addon-product]').removeClass('is-active');
      }
      (0, _jquery2.default)(_dom2.default.finishAddonTrigger).removeClass('is-active');
      (0, _jquery2.default)(_dom2.default.customFinishAddon).val(null);
      (0, _jquery2.default)(_dom2.default.customFinishAddonId).val(null);

      _jsCookie2.default.remove('finish_type');
      (0, _jquery2.default)(_dom2.default.customFinish).val(null);
      (0, _jquery2.default)(_dom2.default.customFinishId).val(null);
      (0, _jquery2.default)(_dom2.default.customFinishPrice).val(null);
      // update price back to default in top and atc button
      var price = parseFloat($product.attr('data-price'));
      var final_price = currency.formatMoney(price, "${{amount}} " + shopCurrency);

      (0, _jquery2.default)('[data-product-price]').html(final_price);
      (0, _jquery2.default)('[data-add-to-cart-price]').html(final_price);

      var compare_price = parseFloat($product.attr('data-compare-price'));
      if (compare_price > 0) {
        var final_compare_price = currency.formatMoney(compare_price, "${{amount}} " + shopCurrency);

        (0, _jquery2.default)('[data-product-compare-price]').html(final_compare_price).removeClass('hide');
      }

      if ($finish.closest('[data-finish-panel]').length > 0) {
        $finish.closest('[data-finish-panel]').find(_dom2.default.finishAddon).removeClass('is-active');
      }
    }
  });
};

var clearCookies = function clearCookies() {
  _jsCookie2.default.remove('finish_price');
  _jsCookie2.default.remove('finish_type');
  _jsCookie2.default.remove('finish_code');
};

var init = exports.init = function init() {
  clearCookies();
  bindUIActions();
};